"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _EditLabels = _interopRequireDefault(require("./EditLabels"));

var _assetHasChanges = _interopRequireDefault(require("../utils/assetHasChanges"));

var _DisplayLabels = _interopRequireDefault(require("../../../../../components/DisplayLabels"));

var _AssetTitle = _interopRequireDefault(require("../../../../../../../common/components/AssetTitle"));

var _utils = require("../../../../../../../common/utils");

require("../styles/_asset.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AssetComponent = /*#__PURE__*/function (_Component) {
  _inherits(AssetComponent, _Component);

  var _super = _createSuper(AssetComponent);

  function AssetComponent() {
    var _this;

    _classCallCheck(this, AssetComponent);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "showLabels", function () {
      _this.setState({
        showLabels: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "hideLabels", function () {
      _this.setState({
        showLabels: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setDragging", function (e) {
      var dragging = _this.state.dragging;
      var _this$props = _this.props,
          setFileDropIndex = _this$props.setFileDropIndex,
          clipIndex = _this$props.clipIndex;
      var rect = document.getElementById("".concat(_this.props.clipId, "-card")).getBoundingClientRect();
      var x = e.clientX - rect.left;
      var indicator = x <= rect.width / 2 ? 'before' : 'after';

      if (dragging === indicator) {
        return;
      }

      _this.setState({
        dragging: indicator
      }, function () {
        var dragging = _this.state.dragging;
        setFileDropIndex(dragging === 'before' ? clipIndex : clipIndex + 1);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "unsetDragging", function (e) {
      var dragging = _this.state.dragging;
      var setFileDropIndex = _this.props.setFileDropIndex;

      if (dragging === false || _this._asset && e.relatedTarget && _this._asset.current.contains(e.relatedTarget)) {
        return;
      }

      _this.setState({
        dragging: false
      }, function () {
        setFileDropIndex(void 0);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getMenuOptions", function () {
      var _this$props2 = _this.props,
          onRemoveAssetFromProject = _this$props2.onRemoveAssetFromProject,
          viewAssetDetails = _this$props2.viewAssetDetails,
          canUpdateVideo = _this$props2.canUpdateVideo,
          hasArchiveAssetsPermission = _this$props2.hasArchiveAssetsPermission,
          hasDeleteAssetsPermission = _this$props2.hasDeleteAssetsPermission,
          onArchiveAsset = _this$props2.onArchiveAsset,
          onDeleteAsset = _this$props2.onDeleteAsset,
          asset = _this$props2.asset,
          hasCommentPermission = _this$props2.hasCommentPermission,
          onAddComments = _this$props2.onAddComments,
          clipId = _this$props2.clipId;
      var isMissing = (0, _utils.isAssetMissing)(asset);
      var isTempClipId = clipId.includes('clip-');
      return [(0, _utils.optionalActionMenuItem)({
        action: viewAssetDetails,
        label: 'Asset Details'
      }, asset && !isMissing), // Labels removed for now, added back in later
      // optionalActionMenuItem({
      //   action: this.showLabels,
      //   label: 'Edit Labels',
      //   keepOpen: true
      // }, asset && !isMissing && canUpdateVideo && onUpdateLabelsForAsset),
      (0, _utils.optionalActionMenuItem)({
        action: onAddComments,
        label: 'Add Comments'
      }, canUpdateVideo && hasCommentPermission && !isTempClipId), {
        separator: true
      }, // No concept of video vs. project at the moment. Potentially added back in later
      // optionalActionMenuItem({
      //   action: onRemoveAssetFromVideo,
      //   label: 'Remove From Video'
      // }, canUpdateVideo && onRemoveAssetFromVideo),
      (0, _utils.optionalActionMenuItem)({
        action: onRemoveAssetFromProject,
        label: 'Remove From Project'
      }, canUpdateVideo && onRemoveAssetFromProject), (0, _utils.optionalActionMenuItem)({
        action: onArchiveAsset,
        label: 'Archive'
      }, asset && hasArchiveAssetsPermission && onArchiveAsset), (0, _utils.optionalActionMenuItem)({
        action: onDeleteAsset,
        isRed: true,
        label: 'Delete'
      }, asset && hasDeleteAssetsPermission && onDeleteAsset)].filter(Boolean);
    });

    _defineProperty(_assertThisInitialized(_this), "setPopupRef", function (el) {
      _this._popupRef = el;
    });

    _this.state = {
      showLabels: false,
      draggingOver: false
    };
    _this._asset = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  _createClass(AssetComponent, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _assetHasChanges.default)(nextProps, this.props) || !(0, _lodash.default)(nextState, this.state);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          selected = _this$props3.selected,
          asset = _this$props3.asset,
          onChange = _this$props3.onChange,
          onUpdateLabelsForAsset = _this$props3.onUpdateLabelsForAsset,
          selectedLabels = _this$props3.selectedLabels,
          labels = _this$props3.labels,
          canUpdateVideo = _this$props3.canUpdateVideo,
          hideFileTypeIcon = _this$props3.hideFileTypeIcon,
          clipId = _this$props3.clipId;
      var _this$state = this.state,
          showLabels = _this$state.showLabels,
          dragging = _this$state.dragging;
      return /*#__PURE__*/_react.default.createElement("div", {
        onDragOver: this.setDragging,
        onDragLeave: this.unsetDragging,
        onDrop: this.unsetDragging,
        ref: this._asset,
        id: "".concat(clipId, "-card"),
        className: (0, _classnames.default)('asset-selection-asset__container', _defineProperty({}, "asset-selection-asset__container--dragging-".concat(dragging), dragging))
      }, /*#__PURE__*/_react.default.createElement(_uiKit.List.CardItem, {
        className: "asset-selection-asset",
        smallCoverImage: true,
        forceInteractive: true,
        selected: selected,
        customCoverImage: /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
          asset: asset,
          canPlayVideo: true,
          canPlayAudio: true,
          hideFileTypeIcon: hideFileTypeIcon,
          darkMode: true
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "asset-selection-asset__inner"
      }, canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_uiKit.Checkbox, {
        className: "asset-selection-asset__checkbox",
        checked: selected,
        onChange: onChange
      }) : null, /*#__PURE__*/_react.default.createElement("div", {
        className: "asset-selection-asset__inner__header"
      }, asset ? /*#__PURE__*/_react.default.createElement(_AssetTitle.default, {
        assetId: asset.assetId,
        inverseColours: true
      }) : /*#__PURE__*/_react.default.createElement("div", {
        className: "asset-selection-asset__title-placeholder"
      }), /*#__PURE__*/_react.default.createElement(_uiKit.ActionPopup, {
        options: this.getMenuOptions(),
        onClose: this.hideLabels,
        ref: this.setPopupRef
      }, showLabels && onUpdateLabelsForAsset ? /*#__PURE__*/_react.default.createElement(_EditLabels.default, {
        onBack: this.hideLabels,
        onClose: this.hideLabels,
        onUpdateLabelsForAsset: onUpdateLabelsForAsset,
        selectedLabels: selectedLabels
      }) : null)), /*#__PURE__*/_react.default.createElement(_DisplayLabels.default, {
        className: "asset-selection-asset__labels",
        selectedLabels: selectedLabels,
        labels: labels
      }))));
    }
  }]);

  return AssetComponent;
}(_react.Component);

var _default = (0, _commonReact.withAssetSelector)(AssetComponent);

exports.default = _default;